import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import {SharedkeyDataService} from '@service/services/common-services/sharedkey-data.service';
import {ApplicantModel, KeyIdentifierModel} from '@service/models';
import {Subscription} from 'rxjs';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NgForm,
} from '@angular/forms';
import {SsnComponent} from '@shared/form-components/ssn/ssn.component';
import {PhoneNumberComponent} from '@shared/form-components/phone-number/phone-number.component';
import {getInstitutionId} from '../../../constants/constant';
import {environment} from '@env/environment';
import {PhoneNumberOptionModel} from '@shared/form-components/phone-number/phone-number-option.model';

@Component({
    selector: 'cs-additional-info',
    templateUrl: './additional-info.component.html',
    styleUrls: ['./additional-info.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AdditionalInfoComponent),
        multi: true
    }]
})
export class AdditionalInfoComponent implements ControlValueAccessor {
    @ViewChild(NgForm) f: NgForm;
    @ViewChild('ssn') ssnCmp: SsnComponent;
    @ViewChild('homePhone', {read: PhoneNumberComponent}) homePhoneCmp: PhoneNumberComponent;
    @ViewChild('workPhone', {read: PhoneNumberComponent}) workPhoneCmp: PhoneNumberComponent;
    value: ApplicantModel;
    @Input() finalSubmitPageConfig: any;
    @Input() miscellaneousFieldsConfig: any;
    @Input() applicant: ApplicantModel = new ApplicantModel();
    @Input() submitted = false;
    @Input('data-test-id') testId: string = 'additional-info';

    keyIdentifier: KeyIdentifierModel;
    subscription: Subscription;
    institutionSettings = getInstitutionId(environment.env);
    cssWidthClass = this.institutionSettings.singleColumnLayout ? 'col-sm-12' : 'col-md-6';
    homePhoneOptions: PhoneNumberOptionModel = new PhoneNumberOptionModel();

    constructor(private sharedKeyDataService: SharedkeyDataService) {
        this.subscription = sharedKeyDataService.keyIdentifier$
            .subscribe((data) => {
                this.keyIdentifier = data;
                if (this.keyIdentifier.loanPurposeConfig) {
                    // TODO: remove backward compatability after moving to S3
				    this.finalSubmitPageConfig = this.keyIdentifier.loanPurposeConfig.finalSubmitPages?.page1 || this.keyIdentifier.loanPurposeConfig.finalSubmitPages;
                    this.miscellaneousFieldsConfig = this.keyIdentifier.loanPurposeConfig.finalSubmitPages.miscellaneousFields;
                    this.homePhoneOptions.required = this.miscellaneousFieldsConfig?.homePhone === 'required';
                }
            });

    }

    runValidation() {
        this.f.form.markAllAsTouched();
        this.ssnCmp?.touch();
        this.homePhoneCmp?.touch();
        this.workPhoneCmp?.touch();
    }

    /**
     * Invoked when the model has been changed
     */
    onChange(_: ApplicantModel) {
        console.log(_);
    }

    /**
     * Invoked when the model has been touched
     */
    onTouched: () => void = () => {
    }

    /**
     * Method that is invoked on an update of a model.
     */
    updateChanges() {
        this.onChange(this.value);
    }

    /**
     * Registers a callback function that should be called when the control's value changes in the UI.
     * @param fn
     */
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    /**
     * Registers a callback function that should be called when the control receives a blur event.
     * @param fn
     */
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    /**
     * Writes a new item to the element.
     * @param value the value
     */
    writeValue(value: ApplicantModel): void {
        this.applicant = value;
    }

}
